import { Flex, Heading, Image, Table, Text } from '@chakra-ui/react';
import { Tooltip } from '@components/ui/tooltip';
import { allCommodities } from 'helpers/fakeData';
import Link from 'next/link';
import { InfoIcon } from 'vectors';

interface Props {
  commodityHref: (id: string) => string;
}
const TrendingCommodities = ({ commodityHref }: Props) => {
  const commodities = allCommodities.slice(0, 5);
  return (
    <Flex
      direction="column"
      gap={2}
      p={4}
      borderRadius="xl"
      borderColor="border.light"
      borderWidth="1px"
      background="linear-gradient(rgba(131, 204, 255, 0.16) 0%, rgba(131, 204, 255, 0) 100%)"
    >
      <Heading>Trending contracts</Heading>
      <Table.Root borderSpacing={'0 8px'} borderCollapse="separate">
        <Table.Header>
          <Table.Row bg="transparent">
            <Table.ColumnHeader border="none" p={0} />
            <Table.ColumnHeader border="none" fontWeight="medium" color="text.secondary" p={0}>
              <Flex direction="row" gap={1} alignItems="center" justifyContent="flex-end">
                <Tooltip
                  content="The total amount of money deposited into contracts"
                  openDelay={0}
                  closeDelay={0}
                >
                  <InfoIcon />
                </Tooltip>
                <Text>Total Deposits</Text>
              </Flex>
            </Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {commodities.map((item, index) => (
            <Table.Row key={item.id} bgColor="surface.background">
              <Table.Cell borderTopLeftRadius="lg" borderBottomLeftRadius="lg">
                <Flex direction="row" gap={1} alignItems="center">
                  <Image src={item.image} alt={item.name} boxSize="32px" />
                  <Link href={commodityHref(item.id)} style={{ textDecoration: 'none' }}>
                    <Text fontSize="sm" fontWeight="medium">
                      {item.name}
                    </Text>
                  </Link>
                </Flex>
              </Table.Cell>
              <Table.Cell
                textAlign="end"
                borderTopRightRadius="lg"
                borderBottomRightRadius="lg"
                fontWeight="medium"
              >{`GHS${(index + 1) * 10000}`}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Flex>
  );
};

export default TrendingCommodities;
